// fonts main
import { faRocketLaunch as iconEntryMain } from "@fortawesome/pro-thin-svg-icons";
import { faMessage as iconMessagingMain } from "@fortawesome/pro-thin-svg-icons";
import { faMessageDots as iconDirectMessagingMain } from "@fortawesome/pro-thin-svg-icons";
import { faCalendarDay as iconCalendar } from "@fortawesome/pro-thin-svg-icons";
import { faUsersViewfinder as iconTribeFinder } from "@fortawesome/pro-thin-svg-icons";
import { faInfoCircle as iconInfo } from "@fortawesome/pro-thin-svg-icons";
import { faHome as iconHome } from "@fortawesome/pro-solid-svg-icons";
import { faGrid as iconMenu } from "@fortawesome/pro-thin-svg-icons";
import { faAtomSimple as iconEvents } from "@fortawesome/pro-thin-svg-icons";
import { faCogs as iconSettings } from "@fortawesome/pro-thin-svg-icons";
import { faSignIn as iconConnect } from "@fortawesome/pro-thin-svg-icons";
import { faCodePullRequest as iconRequests } from "@fortawesome/pro-thin-svg-icons";
import { faMessage as iconContact } from "@fortawesome/pro-thin-svg-icons";
import { faUserCircle as iconPeopleContacts } from "@fortawesome/pro-thin-svg-icons";
import { faHeadVr as iconProfile } from "@fortawesome/pro-thin-svg-icons";
import { faSignature as iconProfileName } from "@fortawesome/pro-thin-svg-icons";
import { faImageUser as iconProfileAvatar } from "@fortawesome/pro-thin-svg-icons";
import { faCreditCardBlank as iconPayment } from "@fortawesome/pro-thin-svg-icons";
import { faCreditCardAlt as iconPaymentMethods } from "@fortawesome/pro-thin-svg-icons";
import { faReceipt as iconReceipt } from "@fortawesome/pro-thin-svg-icons";
import { faBank as iconIncome } from "@fortawesome/pro-thin-svg-icons";
import { faMoneyBillTransfer as iconIncomeBank } from "@fortawesome/pro-thin-svg-icons";
import { faCoins as iconIncomeBalance } from "@fortawesome/pro-thin-svg-icons";
import { faLock as iconSecurity } from "@fortawesome/pro-thin-svg-icons";
import { faAt as iconSecurityEmail } from "@fortawesome/pro-thin-svg-icons";
import { faUserSecret as iconSecurityPassword } from "@fortawesome/pro-thin-svg-icons";
import { faCheckToSlot as iconSecurityMfa } from "@fortawesome/pro-thin-svg-icons";
import { faPassport as iconAccount } from "@fortawesome/pro-thin-svg-icons";
import { faTrashAlt as iconAccountClose } from "@fortawesome/pro-thin-svg-icons";

// entzy assets
import imageTribe from "assets/heros/community-signal.png";
import imageEventuators from "assets/heros/events-bar.png";
import imageCalendar from "assets/heros/calendar-confirmed.png";
import imageContacts from "assets/heros/map-member.png";
import imageMessages from "assets/heros/message-alert.png";
import imageActivity from "assets/heros/activity-alert.png";

/**
 * Main Menu Item Object Definition
 * @typedef {Object} MainMenuItem
 * @property {string} id
 * @property {string} name
 * @property {string} nav
 * @property {string} [parentId]
 * @property {string} [description]
 * @property {string} [nameAlt]
 * @property {boolean} main
 * @property {boolean} parent
 * @property {boolean} connected
 * @property {boolean} [homePage]
 * @property {boolean} [titleOnly]
 * @property {boolean} [bookend]
 * @property {boolean} [admin]
 * @property {FontAwesomeIcon} [icon]
 * @property {string} [bgImage]
 */

/**
 * Create Main Menu Item Object
 * @param {Object} params
 * @param {string} params.id
 * @param {string} params.name
 * @param {string} params.nav
 * @param {string} [params.parentId]
 * @param {string} [params.description]
 * @param {string} [params.nameAlt]
 * @param {boolean} params.main
 * @param {boolean} params.parent
 * @param {boolean} params.connected
 * @param {boolean} [params.homePage]
 * @param {boolean} [params.titleOnly]
 * @param {boolean} [params.bookend]
 * @param {boolean} [params.admin]
 * @param {FontAwesomeIcon} [params.icon]
 * @param {string} [params.bgImage]
 * @returns {MainMenuItem}
 */
export function createMainMenuItem({
  id,
  name,
  nav,
  parentId = null,
  description = null,
  nameAlt = null,
  main,
  parent,
  connected,
  homePage = false,
  titleOnly = false,
  bookend = false,
  admin = false,
  icon = null,
  bgImage = null,
}) {
  return {
    id,
    name,
    nav,
    parentId,
    description,
    nameAlt,
    main,
    parent,
    connected,
    homePage,
    titleOnly,
    bookend,
    admin,
    icon,
    bgImage,
  };
}

/**
 * Main Menu List Object Definition
 * @typedef {Object} MainMenuList
 * @property {MainMenuItem[]} Items - An array of main menu items
 */

/**
 * Create Main Menu List
 * @returns {MainMenuList} The created Main Menu List Object
 */
export function createMainMenuList() {
  return [
    createMainMenuItem({
      id: "home",
      name: "Entzy",
      description: "Where to?",
      nav: "/",
      icon: iconHome,
      main: false,
      parent: true,
      bookend: true,
      connected: false,
    }),

    // bookend left
    createMainMenuItem({
      id: "menu",
      name: "Menu",
      nav: "/menu",
      icon: iconMenu,
      main: true,
      parent: true,
      bookend: true,
      connected: false,
    }),

    // core functionality menu
    createMainMenuItem({
      id: "tribe",
      parentId: "home",
      name: "Tribalize",
      description: "Put your signal up",
      nav: "/tribe",
      icon: iconTribeFinder,
      parent: true,
      main: true,
      connected: true,
      homePage: true,
      bgImage: imageTribe,
    }),
    createMainMenuItem({
      id: "eventuators",
      parentId: "home",
      name: "Eventuate",
      description: "Share places & dates",
      nav: "/eventuators",
      icon: iconEvents,
      parent: true,
      main: true,
      connected: false,
      homePage: true,
      bgImage: imageEventuators,
    }),
    createMainMenuItem({
      id: "calendar",
      parentId: "home",
      name: "Calendar",
      description: "Track matched meets",
      nav: "/calendar",
      icon: iconCalendar,
      parent: true,
      main: true,
      connected: true,
      homePage: true,
      bgImage: imageCalendar,
    }),
    createMainMenuItem({
      id: "contacts",
      parentId: "home",
      name: "Contacts",
      description: "Grow your tribe",
      nav: "/contacts",
      icon: iconPeopleContacts,
      parent: true,
      main: true,
      connected: true,
      homePage: true,
      bgImage: imageContacts,
    }),
    createMainMenuItem({
      id: "messages",
      parentId: "home",
      name: "Messages",
      description: "Your message feed",
      nav: "/messages",
      icon: iconMessagingMain,
      parent: true,
      main: true,
      connected: true,
      homePage: true,
      bgImage: imageMessages,
    }),
    createMainMenuItem({
      id: "activity",
      parentId: "home",
      name: "Activity",
      description: "Your activity feed",
      nav: "/activity",
      icon: iconEntryMain,
      parent: true,
      main: true,
      connected: true,
      homePage: true,
      bgImage: imageActivity,
    }),
    createMainMenuItem({
      id: "direct-messages",
      parentId: "messages",
      name: "Direct Connections",
      description: "Your direct connects",
      nav: "/@/",
      icon: iconDirectMessagingMain,
      parent: true,
      main: true,
      connected: true,
    }),

    // settings menu
    createMainMenuItem({
      id: "settings",
      parentId: "home",
      name: "Settings",
      nav: "/settings",
      description: "Configure your account",
      icon: iconSettings,
      parent: true,
      main: true,
      titleOnly: true,
      connected: true,
    }),
    // settings profile menu
    createMainMenuItem({
      id: "settings-profile",
      parentId: "settings",
      name: "Profile",
      description: "Thinking about a new look?",
      nav: "/settings/profile",
      icon: iconProfile,
      parent: true,
      main: false,
      connected: true,
    }),
    createMainMenuItem({
      id: "settings-profile-name",
      parentId: "settings-profile",
      name: "Name",
      description: "Manage your profile name",
      nav: "/settings/profile/name",
      icon: iconProfileName,
      connected: true,
    }),
    createMainMenuItem({
      id: "settings-profile-avatar",
      parentId: "settings-profile",
      name: "Avatar",
      description: "Manage your profile image",
      nav: "/settings/profile/avatar",
      icon: iconProfileAvatar,
      connected: true,
    }),
    // settings payment menu
    createMainMenuItem({
      id: "settings-payment",
      parentId: "settings",
      name: "Payment",
      description: "Manage your payment settings",
      nav: "/settings/payment",
      icon: iconPayment,
      parent: true,
      main: false,
      connected: true,
    }),
    createMainMenuItem({
      id: "settings-payment-methods",
      parentId: "settings-payment",
      name: "Methods",
      description: "Payment method for rider purchases",
      nav: "/settings/payment/methods",
      icon: iconPaymentMethods,
      connected: true,
    }),
    createMainMenuItem({
      id: "settings-payment-history",
      parentId: "settings-payment",
      name: "Transactions",
      description: "View payment history and receipts",
      nav: "/settings/payment/history",
      icon: iconReceipt,
      connected: true,
    }),
    // settings income menu
    createMainMenuItem({
      id: "settings-income",
      parentId: "settings",
      name: "Income",
      description: "Manage your income settings",
      nav: "/settings/income",
      icon: iconIncome,
      parent: true,
      main: false,
      connected: true,
    }),
    createMainMenuItem({
      id: "settings-income-bank",
      parentId: "settings-income",
      name: "Bank Link",
      description: "Link a bank account for receiving runner income",
      nav: "/settings/income/bank",
      icon: iconIncomeBank,
      connected: true,
    }),
    createMainMenuItem({
      id: "settings-income-balance",
      parentId: "settings-income",
      name: "Transactions",
      description: "View and manage your income account",
      nav: "/settings/income/balance",
      icon: iconIncomeBalance,
      connected: true,
    }),
    // settings security menu
    createMainMenuItem({
      id: "settings-security",
      parentId: "settings",
      name: "Security",
      description: "Manage your security settings",
      nav: "/settings/security",
      icon: iconSecurity,
      parent: true,
      main: false,
      connected: true,
    }),
    createMainMenuItem({
      id: "settings-security-email",
      parentId: "settings-security",
      name: "Email",
      description: "Manage your connected email address",
      nav: "/settings/security/email",
      icon: iconSecurityEmail,
      connected: true,
    }),
    createMainMenuItem({
      id: "settings-security-password",
      parentId: "settings-security",
      name: "Password",
      description: "Manage your connection password",
      nav: "/settings/security/password",
      icon: iconSecurityPassword,
      connected: true,
    }),
    createMainMenuItem({
      id: "settings-security-mfa",
      parentId: "settings-security",
      name: "MFA",
      description: "Setup multi-factor authentication",
      nav: "/settings/security/mfa",
      icon: iconSecurityMfa,
      connected: true,
    }),
    // settings account menu
    createMainMenuItem({
      id: "settings-account",
      parentId: "settings",
      name: "Account",
      description: "Account level settings",
      nav: "/settings/account",
      icon: iconAccount,
      parent: true,
      main: false,
      connected: true,
    }),
    createMainMenuItem({
      id: "settings-account-close",
      parentId: "settings-account",
      name: "Close Account",
      description: "Permanently close your account",
      nav: "/settings/account/close",
      icon: iconAccountClose,
      connected: true,
    }),

    // footer main settings
    createMainMenuItem({
      id: "entzy",
      name: "Entzy",
      main: true,
      titleOnly: true,
      connected: true,
    }),
    createMainMenuItem({
      id: "about",
      name: "About Entzy",
      description: "About Entzy and how it works",
      nav: "/about",
      icon: iconInfo,
      main: true,
      parent: true,
      connected: true,
    }),
    createMainMenuItem({
      id: "features",
      name: "Feature Request",
      description: "Connect with Entzy to improve the platform",
      nav: "/features",
      icon: iconRequests,
      main: true,
      parent: true,
      connected: true,
    }),
    createMainMenuItem({
      id: "support",
      name: "Get in Touch",
      description: "Connect with Entzy for support",
      nav: "/support",
      icon: iconContact,
      main: true,
      parent: true,
      connected: false,
    }),
    createMainMenuItem({
      id: "admin",
      name: "Admin",
      description: "Admin Settings",
      nav: "/admin",
      icon: iconSettings,
      main: true,
      parent: true,
      connected: true,
      admin: true,
    }),

    // bookend right
    createMainMenuItem({
      id: "connect",
      name: "Connect",
      nameAlt: "Disconnect",
      nav: "/connect",
      icon: iconConnect,
      main: true,
      parent: true,
      bookend: true,
      connected: false,
    }),
  ];
}
